import { cpvAPI } from "@/api/cpv/cpv.api";
import { AxiosObservable } from "axios-observable";

const cpvApi = new cpvAPI();

const listVereadores = (
  params
): AxiosObservable<any> => {
  return cpvApi.listVereadores(params);
};

const listVehicles = (
  params
): AxiosObservable<any> => {
  return cpvApi.listVehicles(params);
};
const getById = (
  id : number
): AxiosObservable<any> => {
  return cpvApi.getById(id);
};
const getVehiclebyPlate = (
  plate : string
): AxiosObservable<any> => {
  return cpvApi.getVehiclebyPlate(plate);
};
const vereadorCanUpdateVehicle = (
  vereadorId : number
): AxiosObservable<any> => {
  return cpvApi.vereadorCanUpdateVehicle(vereadorId);
};
const endMandateById = (
  id: number,
): AxiosObservable<any> => {
  return cpvApi.endMandateById(id);
};

const checkPlateOnDetran = (
  plateOnDetran : string
): AxiosObservable<any> => {
  const normalizedPlate = String(plateOnDetran || "").toUpperCase();

  return cpvApi.checkPlateOnDetran(normalizedPlate);
};

const updateVehiclePlate = (
    formData: FormData
): AxiosObservable<any> => {
  return cpvApi.updateVehiclePlate(formData);
};

const createVereador = (
  formData: FormData
): AxiosObservable<any> => {
  return cpvApi.createVereador(formData);
};

const retriveDashboardData = (
  presidenteId: string
): AxiosObservable<any> => {
  return cpvApi.retriveDashboardData(presidenteId);
};

const patchVereador = (
  id: number,
   payload: {
    id: number;
    cpf: string;
    nome: string;
    telefone: string;
    email: string;
    dataFimVigencia: string;
    situacaoMandato: string;
    camaraId: string;
  }
  ): AxiosObservable<any> => {
    return cpvApi.patchVereador(id , payload)
  };

const downloadAutorizacaoVeicular = (
  veiculoId: number
): AxiosObservable<Blob> => {
  return cpvApi.downloadAutorizacaoVeicular(veiculoId);
};

const validateCertidaoVeicular = (
  token: string
): AxiosObservable<any> => {
  return cpvApi.validateCertidaoVeicular(token);
};

export default {
  listVereadores,
  vereadorCanUpdateVehicle,
  listVehicles,
  getById,
  getVehiclebyPlate,
  endMandateById,
  checkPlateOnDetran,
  updateVehiclePlate,
  createVereador,
  retriveDashboardData,
  patchVereador,
  downloadAutorizacaoVeicular,
  validateCertidaoVeicular
};
